import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import FumbleForcedByPositionPref from "./position-pref/fumble-forced-by-position-pref";
import PatFumbleForcedByPositionPref from "./position-pref/pat-fumble-forced-by-position-pref";
import FootballState from "../state/football-state";
import { isArray } from "../../../services/common/object-util";
import PatResultType from "../enums/pat-result-type";

export default class Fumble extends Fragment {
    constructor(forcedBy) {
        super();
        this.passResultCode = "F";
        this.patCode = PatResultType.FUMBLED.code;
        this.forcedBy = forcedBy;

        this.requiredData = [
            {
                name: "forcedBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Forced by",
                title: (team) => `Forced By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true,
                optional: true,
                //TODO: Do we need this here? Looks like not. -> isSkipped: () => this.forcedBy && !this.forcedBy?.id
                positionPref: (play) =>
                    play.historyContains(FootballState.PatTry)
                        ? new PatFumbleForcedByPositionPref(
                              play,
                              this
                          ).resolve()
                        : new FumbleForcedByPositionPref(play, this).resolve()
            }
        ];
    }

    getPlayers() {
        return this.forcedBy?.id ? [this.forcedBy] : [];
    }

    summarize(summaryContext, stringifier) {
        const { gameConfig, fieldPosition, homeTeam, awayTeam } =
            summaryContext;
        const messages = [];

        messages.push(
            `to ${stringifier.niceFieldPosition(
                gameConfig.general.fieldLength,
                fieldPosition,
                homeTeam?.abbrName,
                awayTeam?.abbrName
            )}`
        );

        if (this.forcedBy?.id) {
            messages.push(
                `fumble forced by ${stringifier.firstInitial(this.forcedBy)}`
            );
        }

        messages.push(
            `fumble by ${stringifier.firstInitial(
                summaryContext.playerInPossession
            )}`
        );

        return new FragmentSummary(messages.join(", "));
    }

    toJSON() {
        if (isArray(this.forcedBy)) {
            throw new Error("forcedBy cannot be an array");
        }

        return {
            ...super.toJSON(),
            forcedBy: playerReducer(this.forcedBy)
        };
    }
}
